export class VerifyCodeInvalidError extends Error {
  public constructor() {
    super()

    this.message = 'errors.verifyCodeInvalid'
  }
}
